import { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { xs, sm, md, lg, xl, explicitlyDefineScreenBrackets } from '../utils/media';
import { colours } from 'themes/default';

const defaultHorizontalGutter = 1;

export const calculateGutter = ({ space, spaceWithin, borderWidth, theme: { horizontalGutter } }) => {
  let gutterWidth = 0;
  if (space === 'horizontal' || space === true) {
    gutterWidth += horizontalGutter || defaultHorizontalGutter;
  }
  if (spaceWithin === 'horizontal' || spaceWithin === true) {
    gutterWidth += horizontalGutter || defaultHorizontalGutter;
  }

  if (borderWidth) {
    return `calc(${gutterWidth}rem + ${2 * borderWidth}px)`;
  }

  return `${gutterWidth}rem`;
};

export const getWidthAtBreakpoint = (props, breakpoint, mediaQuery) => {
  const { width } = explicitlyDefineScreenBrackets(props);
  if (width && width[breakpoint] !== undefined) {
    if (width[breakpoint] === 0) {
      return css`
        display: none;
      `;
    }
    if (typeof width[breakpoint] === 'number') {
      return mediaQuery`width: calc(${(width[breakpoint] * 100) / 12}% - ${calculateGutter(props)})`;
    }
    if (width[breakpoint] === 'natural') {
      return null;
    }

    return css`
      width: ${width[breakpoint]};
    `;
  }

  return null;
};

export const responsiveWidthStyles = css`
  ${(props) => getWidthAtBreakpoint(props, 'xs', xs)};
  ${(props) => getWidthAtBreakpoint(props, 'sm', sm)};
  ${(props) => getWidthAtBreakpoint(props, 'md', md)};
  ${(props) => getWidthAtBreakpoint(props, 'lg', lg)};
  ${(props) => getWidthAtBreakpoint(props, 'xl', xl)};
`;

const marginAndPaddingStyles = (props) => {
  const { space, spaceWithin } = props;
  let paddingHorizontal = 0;
  let paddingVertical = 0;
  let marginHorizontal = 0;
  let marginVertical = 0;

  if (space === 'vertical' || space === true) {
    marginVertical = `calc(1rem / 2)`;
  }
  if (space === 'horizontal' || space === true) {
    marginHorizontal = `calc(1rem / 2)`;
  }
  if (spaceWithin === 'vertical' || spaceWithin === true) {
    paddingVertical = `calc(1rem / 2)`;
  }
  if (spaceWithin === 'horizontal' || spaceWithin === true) {
    paddingHorizontal = `calc(1rem / 2)`;
  }

  return css`
    margin: ${marginVertical} ${marginHorizontal};
    padding: ${paddingVertical} ${paddingHorizontal};
  `;
};

export default css`
  ${marginAndPaddingStyles};
  ${responsiveWidthStyles};
  ${ifProp(
    'borderWidth',
    css`
      border: ${({ borderWidth }) => borderWidth}px solid ${colours.Shades.TintBlue10};
      border-color: ${colours.Shades.TintBlue10};
      border-radius: 0.35em;
    `
  )};
`;
